import {
    getfeemaster,
    getListFeemaster,
    getFeemasterTemplate,
    createFeemaster,
    deletefeemaster,
    editfeemaster
} from "@/http/setup/feeMaster";


export default {
    namespaced: true,
    state: {
        FeeMaster: {},
        ListFeeMaster: [],
        FeeMasterTemplate: {},
        CreateFeeMaster: null,
    },
    actions: {
        async setfeemaster({ commit }, id) {
            const resp = await getfeemaster(id);
            commit('SET_FEE_MASTER', resp.data);
            return resp;
        },
        async setListFeemaster({ commit }) {
            const resp = await getListFeemaster();
            commit('SET_LIST_FEEMASTER', resp.data);
            return resp;
        },
        async setFeemasterTemplate({ commit }) {
            const resp = await getFeemasterTemplate();
            commit('SET_FEEMASTER_TEMPLATE', resp.data);
            return resp;
        },
        async createFeemasterAction({ commit }, data) {
            const resp = await createFeemaster(data);
            commit('CREATE_FEEMASTER_ACTION', resp.data.resourceId);
            return resp;
        },
        async deletefeemasterAction({ commit }, data) {
            const resp = await deletefeemaster(data);
            return resp;
        },
        async editfeemasterAction({ commit }, data) {
            const resp = await editfeemaster(data.id, data.data);
            return resp;
        },
    },
    mutations: {
        ['SET_FEE_MASTER'](state, payload) {
            Object.assign(state, { FeeMaster: payload });
        },
        ['SET_LIST_FEEMASTER'](state, payload) {
            Object.assign(state, { ListFeeMaster: payload });
        },
        ['SET_FEEMASTER_TEMPLATE'](state, payload) {
            Object.assign(state, { FeeMasterTemplate: payload });
        },
        ['CREATE_FEEMASTER_ACTION'](state, payload) {
            Object.assign(state, { CreateFeeMaster: payload });
        },
    }
}